/**
 * Mapping `timeScale` (du composant standard `vl-widget-period-filters`)
 * vers une plage de dates [start, end]. Partagé entre les widgets Qualité
 * (NC stats, supplier compliance, …) pour cohérence des filtres période.
 *
 * Valeurs supportées (alignées sur l'enum interne du composant) :
 *  - "1 m"  : 1 mois glissant (today-1mois → today)
 *  - "6 m"  : 6 mois glissants
 *  - "YTD"  : Year-To-Date (1er janvier → today)
 *  - "EX"   : exercice courant (1er janvier → 31 décembre)
 *  - "1 a"  : 12 mois glissants
 *  - "5 a"  : 5 ans glissants
 *
 * Convention : un "exercice" = année calendaire (Justup ne gère pas encore
 * les exercices décalés). À externaliser plus tard si besoin.
 */
export function periodBoundsFromTimeScale(
  scale: string,
  today: Date = new Date(),
): { start: Date; end: Date } {
  const y = today.getFullYear();
  const m = today.getMonth();
  const d = today.getDate();
  switch (scale) {
    case "1 m":
      return { start: new Date(y, m - 1, d), end: today };
    case "6 m":
      return { start: new Date(y, m - 6, d), end: today };
    case "YTD":
      return { start: new Date(y, 0, 1), end: today };
    case "EX":
      return { start: new Date(y, 0, 1), end: new Date(y, 11, 31, 23, 59, 59) };
    case "1 a":
      return { start: new Date(y - 1, m, d), end: today };
    case "5 a":
      return { start: new Date(y - 5, m, d), end: today };
    default:
      // Fallback safe : YTD
      return { start: new Date(y, 0, 1), end: today };
  }
}

/** Format Local YYYY-MM-DD (évite décalage timezone d'`toISOString`). */
export function toLocalIsoDay(d: Date): string {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
}
